'use client';

import { isSupportedAppVersion } from '@weberus/ui/utils/app-version-checker';
import { yaNative } from '@weberus/ui/utils/ya-native';
import { EmptyState } from '@yanolja-rnd/nol-design-system';

import { IcErrorH72 } from '@yanolja-rnd/nol-icons';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  const handleClickRetry = async () => {
    const isSupported = await isSupportedAppVersion('9.4.0');

    if (!isSupported || !yaNative.isEnabled) {
      window.location.reload();
    } else {
      yaNative.reloadWebPage({});
    }
  };

  const handleClickBack = () => {
    router.back();
  };

  return (
    <div className="flex h-full w-full items-center justify-center bg-static-white">
      <EmptyState
        icon={IcErrorH72}
        title="화면을 불러오지 못했어요"
        buttons={[
          {
            content: '다시 시도하기',
            onClick: handleClickRetry,
          },
          {
            content: '뒤로 가기',
            onClick: handleClickBack,
          },
        ]}
      />
    </div>
  );
}
